import { Form } from 'semantic-ui-react';
export default Form;